// import { width } from '@mui/system';
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import "../Components/Component-css/Header.css";
import css from "./Component-css/Nav.module.css";
import BottonMenu from "../uiComponents/BottonMenu";
import { IoMdNotificationsOutline } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import "../Components/Component-css/Header.css";
import { IoIosAdd, IoMdArrowRoundBack } from "react-icons/io";
import Swal from "sweetalert2";
import { apiRequest } from "../store/allApi";
import Socket from "./../Components/socket";
import io from "../Components/socket";

const w3_close = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  if (!sidebar) return;

  const width = sidebar.offsetWidth || 0;
  sidebar.style.left = `-${width}px`;

  if (overlay) overlay.style.display = "none";
};

const w3_open = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");

  if (!sidebar) return;

  sidebar.style.left = "0";

  if (overlay) overlay.style.display = "block";
};

const addsetting = localStorage.getItem("sitSetting");
const udata = localStorage.getItem("udata");
const addCaseSetting = JSON.parse(addsetting);

const Header = ({ user }) => {
  // console.log(user)

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  const userData = localStorage.getItem("udata");
  const udata = JSON.parse(userData);

  const handleClick = () => {
    // if (udata?.verified === "verified") {
      history.push("/addcase");
    // } else {
    //   Swal.fire({
    //     title: "Complete your KYC",
    //     text: "कृपया 👉 Deposit  add करने से पहले KYC कम्पलीट करें 🙏",
    //     icon: "warning",
    //     confirmButtonText: "Go to Profile",
    //     showCancelButton: true,
    //     cancelButtonText: "Cancel",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       history.push("/profile"); // Change path if your route is different
    //     }
    //   });
    // }
  };

  useEffect(() => {
    io.on("setProfile", (data) => {
      setOpen(data.superUser);
      localStorage.setItem("udata", JSON.stringify(data));
    });
  }, [Socket]);

  const [open, setOpen] = useState(false);
  const history = useHistory();

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const logout = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest("logout", "POST", null, headers);
      if (res.data) {
        // setUser(res.data)
        localStorage.removeItem("token");
        localStorage.removeItem("phone");
        window.location.reload();
        history.push("/");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        localStorage.removeItem("phone");
      }
    }
    // axios
    //   .post(
    //     baseUrl+`logout`,
    //     {
    //       headers: headers
    //     },
    //     { headers }
    //   )
    //   .then(res => {
    //     // setUser(res.data)
    //     localStorage.removeItem('token')
    //     localStorage.removeItem('phone')
    //     window.location.reload()
    //     history.push('/')
    //   })
    //   .catch(e => {
    //     if (e.response.status == 401) {
    //       localStorage.removeItem('token')
    //       localStorage.removeItem('token')
    //       localStorage.removeItem('phone')
    //     }
    //   })
  };

  const navigate = useHistory();

  const handleBackClick = (e) => {
    e.preventDefault(); // Stop default anchor action

    // SweetAlert pop-up
    Swal.fire({
      title: "चेतावनी ",
      text: "अगर आपका गेम चल रहा हे और आप चलते गेम में बैक करते हो तो आप गेम हार जायेंगे | बैक जाने के लिए YES करे और गेम जारी रकने के लिए NO करे | ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      customClass: {
        popup: "custom-swal-popup", // Apply custom class to the SweetAlert popup
      },
    }).then((result) => {
      if (result.isConfirmed) {
        history.push("/"); // Redirect to home page
      }
      // If 'No', nothing happens and the user stays on the page
    });
  };

  //  Download App
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const currentPath = window.location.pathname;

  useEffect(() => {
    if (currentPath === "/aviator") {
      const handleKeydown = (e) => {
        console.log(e);
        if ((e.key === "r" || e.key === "R") && (e.ctrlKey || e.metaKey)) {
          e.preventDefault();
          console.log("refresh");
        }
      };

      // Attach the event listener
      document.addEventListener("keydown", handleKeydown);

      // Clean up the event listener on component unmount
      return () => {
        document.removeEventListener("keydown", handleKeydown);
      };
    }
  }, [currentPath]);

  // app download
  // const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false);

  useEffect(() => {
    const data = localStorage.getItem("udata");
    const userData = JSON.parse(data);
    setOpen(userData?.superUser);

    const handler = (e) => {
      e.preventDefault();
      console.log("beforeinstallprompt event was fired");
      setPromptInstall(e);
      setSupportsPWA(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      console.log("No promptInstall event available");
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
      setPromptInstall(null);
    });
  };

  return (
    <>
      <div>
        {/* {
          currentPath === "/aviator" ? "" :
            <div className='header_top_message'>
              <span>  {JSON.parse(localStorage.getItem('sitSetting')) == 'undefined'
                ? ''
                : JSON.parse(localStorage.getItem('sitSetting'))
                  ?.header_message}</span>
            </div>
        } */}
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}></div>
            <div
              className="w3-sidebar w3-bar-block"
              id="mySidebar"
              style={{ paddingBottom: "0px" }}
            >
              <div className="king-sidebarbox">
                <div className="d-flex align-items-center">
                  <img className="" src="/logo.png" />
                  <h2>MrLudoHub</h2>
                </div>

                <div>
                 
                   <span  onClick={w3_close}> <img src="/images/back-button.png" /></span>
                </div>
              </div>

              <div className="images-box">


              <Link
                to={"/Profile"}
                className="w3-bar-item w3-button"
                onClick={w3_close}
              >
                <picture className="icon">
                  {user && user.avatar ? (
                    <img
                      width="30px"
                      height="30px"
                      src="/user.png"
                      alt="profile"
                      style={{ borderRadius: "50px" }}
                    />
                  ) : (
                    <img src="../images/avatars/Avatar7.png" alt="profile" />
                  )}
                </picture>
                <div style={{ marginLeft: ".5rem" }}>My Profile</div>
              </Link>

              <Link
                to={"/landing"}
                className="w3-bar-item w3-button"
                onClick={w3_close}
              >
                <picture className="icon">
                  <img
                    alt="img"
                    src={process.env.PUBLIC_URL + "/images/Header/gamepad.png"}
                  />
                </picture>
                <div style={{ marginLeft: ".5rem" }}>Play Game</div>
              </Link>

              {open == true ? (
                <Link
                  to={"/wallet"}
                  className="w3-bar-item w3-button"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img
                      alt="img"
                      src={process.env.PUBLIC_URL + "/images/Header/wallet.png"}
                    />
                  </picture>
                  <div style={{ marginLeft: ".5rem" }}>My wallet</div>
                </Link>
              ) : (
                ""
              )}

              <Link
                to={"/refer"}
                className="w3-bar-item w3-button"
                onClick={w3_close}
              >
                <picture className="icon">
                  <img
                    alt="img"
                    src={
                      process.env.PUBLIC_URL +
                      "/images/icons/earnings.png"
                    }
                  />
                </picture>
                <div style={{ marginLeft: ".5rem" }}>Refer and Earn</div>
              </Link>
              {open == true ? (
                <Link
                  to={"/history"}
                  className="w3-bar-item w3-button"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img
                      alt="img"
                      src={process.env.PUBLIC_URL + "/images/icons/tractions.jpeg"}
                    />
                  </picture>
                  <div style={{ marginLeft: ".5rem" }}>History</div>
                </Link>
              ) : (
                ""
              )}

              {open == true ? (
                <Link
                  to={"/Referral-history"}
                  className="w3-bar-item w3-button"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img
                      alt="img"
                      src={
                        process.env.PUBLIC_URL + "../images/icons/refer-page.png"
                      }
                    />
                  </picture>
                  <div style={{ marginLeft: ".5rem" }}>Refer History</div>
                </Link>
              ) : (
                ""
              )}

              <Link
                to={"/Notification"}
                className="w3-bar-item w3-button"
                onClick={w3_close}
              >
                <picture className="icon">
                  <img
                    alt="img"
                    src={
                      process.env.PUBLIC_URL +
                      "/images/icons/bell.png"
                    }
                  />
                </picture>
                <div style={{ marginLeft: ".5rem" }}>Notification</div>
              </Link>

              {open == true ? (
                <Link
                  to={"/support"}
                  className="w3-bar-item w3-button"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img
                      alt="img"
                      src={
                        process.env.PUBLIC_URL + "/images/icons/supportt.png"
                      }
                    />
                  </picture>
                  <div style={{ marginLeft: ".5rem" }}>Support</div>
                </Link>
              ) : (
                ""
              )}
              <div
                className="w3-bar-item w3-button sidebar_link"
                onClick={onClick}
                style={{  fontWeight: "bold" }}
              >
                <picture className="icon">
                  <img alt="img" src="../images/icons/download.png" style={{filter:'brightness(100)'}}/>
                </picture>
                <h3 style={{ fontWeight: "bold" }}>
                  {isdropdownVisible ? " App Download" : " App Download"}
                </h3>
              </div>

              <div
                className="w3-bar-item w3-button sidebar_link"
                onClick={toggleDiv}
              >
                <picture className="icon">
                  <img alt="img" src="../images/icons/policy.png" />
                </picture>
                <h3 style={{ fontWeight: "bold" }}>
                  {isdropdownVisible ? "All Policy" : "All Policy"}
                </h3>
              </div>

              {isdropdownVisible && (
                <ul className="dropdown_link" id="submenu">
                  <li>
                    <Link to="/privacy-policy" onClick={w3_close}>
                      Privacy Policy
                    </Link>
                  </li>
                  {/* <li>
                    <Link to='/shipping-delivery-policy' onClick={w3_close}>
                      Shipping and Delivery Policy
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/RefundPolicy" onClick={w3_close}>
                      Refund/Cancellation Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/term-condition" onClick={w3_close}>
                      Terms &amp; Condition
                    </Link>
                  </li>

                  <li>
                    <Link to="/contact-us" onClick={w3_close}>
                      Contact
                    </Link>
                  </li>
                </ul>
              )}
              </div>

            </div>

            {/* <Link
              to={'/Gamehistory'}
              className='w3-bar-item w3-button'
              onClick={w3_close}
            >
              <picture className='icon'>
                <img
                  alt='img'
                  src={
                    process.env.PUBLIC_URL + '/images/Header/gamesHistory.png'
                  }
                />
              </picture>
              <div style={{ marginLeft: '.5rem' }}>Game History</div>
            </Link> */}
            {/* <Link
              to='/transaction-history'
              className='w3-bar-item w3-button'
              onClick={w3_close}
            >
              <picture className='icon'>
                <img
                  alt='img'
                  src={
                    process.env.PUBLIC_URL + '/tractions.jpeg'
                  }
                />
              </picture>
              <div style={{ marginLeft: '.5rem' }}>Transaction History</div>
            </Link> */}
            <div className="w3-teal">
              <div className="w3-container ">
                <div className={`${css.headerContainer} `}>
                  <div>
                    {currentPath == "/aviator" ? (
                      <a href="/" onClick={handleBackClick}>
                        <IoMdArrowRoundBack />
                      </a>
                    ) : (
                      <button
                        className="w3-button w3-teal w3-xlarge float-left"
                        onClick={w3_open}
                        id="hambergar"
                      >
                        <picture className={`${css.sideNavIcon} mr-0`}>
                          <img
                            src={
                              process.env.PUBLIC_URL + "/images/icons/menu1.png"
                            }
                            className="snip-img"
                            alt=""
                          />
                        </picture>
                      </button>
                    )}
                    <Link to="/">
                      <img
                        src="../logo.png"
                        className="snip-img"
                        alt="logos"
                        width="80px"
                      />
                    </Link>
                  </div>
                  {supportsPWA ? (
                    <div
                      className="app-download"
                      onClick={onClick}
                      disabled={!promptInstall}
                    >
                      <div className="d-flex align-items-center">
                        <picture className="icon icon_style_white blink">
                          <img alt="img" src="../images/icons/download.png" />
                        </picture>
                        <span>App</span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {open === true ? (
                    <div className={`${css.menu_items}`}>
                      <div
                        className={`${css.box}`}
                        onClick={handleClick}
                      >
                        <picture className={`${css.moneyIcon_container}`}>
                          <img
                            src={process.env.PUBLIC_URL + "/images/rupee.png"}
                            className="snip-img w-22"
                            alt=""
                          />
                        </picture>

                        <div className="mt-1">
                          <div className={`${css.moneyBox_header}`}>Coin</div>
                          <div className={`${css.moneyBox_text}`}>
                            {user && user.Wallet_balance}
                          </div>
                        </div>

                        {/* <picture className={`${css.moneyBox_add}`}>
                          <IoIosAdd
                            style={{ fontSize: "24px", color: "#000" }}
                          />
                        </picture> */}
                      </div>

                      <Link
                        className={`${css.box} ml-2`}
                        to="/redeem/refer"
                        style={{ width: "80px" }}
                      >
                        <picture className={`${css.moneyIcon_container}`}>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/LandingPage_img/notification-activity-reward.png"
                            }
                            className="snip-img"
                            alt=""
                          />
                        </picture>
                        <div className="mt-1">
                          <div className={`${css.moneyBox_header}`}>
                            Earning
                          </div>
                          <div className={`${css.moneyBox_text}`}>
                            {user && user.referral_wallet}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="w3-teal ">
            <div className="w3-container ">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2  d-flex`}>
                    <img
                      src="../logo.png"
                      className="snip-img"
                      alt="logos"
                      width="100px"
                    />
                  </picture>
                </Link>

                <div className={`ml-5`}>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu />
      </div>
      <div className="bottom_menus_main">
        {/* <BottonMenu /> */}
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;
